import { useState } from 'react';
import React from 'react';
import './App.css';
import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import { useNavigate } from 'react-router-dom';
import imgLogo from './Portal_SUPPLIER_PORTAL_PWC.png';
import rightLogo from './right_bar.jpg';
import sofHelpIcon from './SOF_Help.jpeg';
import { useAuth } from 'oidc-react';


function Home() {
  const [showHelpModal, setShowHelpModal] = useState(false);
 // const [showHelpModal, setShowHelpModal] = useState(false);

  const helpMessage = (
    <div>
      <p><b>In case the form was not submitted successfully. Please try the troubleshooting steps below before contacting the business team.</b></p>
      <ul>
        <li>Clear your browser cache and cookies</li>
        <li>Go to Home page and try submitting the form again</li>
        <li>Ensure you are using a supported browser (Chrome recommended)</li>
        <li>Verify that you are logged in and your session has not expired</li>
      </ul>
      <p><b>If the issue persists after performing the above steps, please contact the business team for further assistance.</b></p>
    </div>
  );
  const auth = useAuth();

  const [dataDrp, setDrpName] = useState({
    Level1DropDownVal: "",
    Level2DropDownVal: ""
  });
  const navigate = useNavigate();

  let Level2DropDownVals;
  //const Level1DropDownVal = ['-- Select --', '#10291 Scrap Form','#11187A UPPAP Finished Parts Packaging Form','#11187B UPPAP Raw Materials Packaging Form','#11477 Marking & Traceability Approval Form'];
  const Level1DropDownVal = ['-- Select --', '#10291 Scrap Form','#11477 Marking & Traceability Approval Form'];
  const scrapEvalLevel2 = ['-- Select --', '1. New Scrap Evaluation', '2. Confirm Mutilation'];
  const dPMSLevel2 = ['-- Select --', 'Step1-New Marking & Traceability Request', 'Step1-Update Existing Marking Request', 'Step2-Pictures Marking Approval Request'];
  const uPPAP_A_Level2 =['-- Select --', '1. New Finished Parts Request','2. Update Existing Finished Part Request'];
  const uPPAP_B_Level2 =['-- Select --', '1. New Raw Materials Request','2. Update Existing Raw Materials Request'];
  const Level2DropDownVal = ['-- Select --'];
  Level2DropDownVals = Level2DropDownVal.map((Level2DropDownVal, key) => <option key={key} value={Level2DropDownVal}>{Level2DropDownVal}</option>)


  if (dataDrp.Level1DropDownVal === "#10291 Scrap Form") {
    Level2DropDownVals = scrapEvalLevel2.map((scrapEvalLevel2, key) => <option key={key} value={scrapEvalLevel2}>{scrapEvalLevel2}</option>)
  }
  if (dataDrp.Level1DropDownVal === "#11477 Marking & Traceability Approval Form") {
    Level2DropDownVals = dPMSLevel2.map((dPMSLevel2, key) => <option key={key} value={dPMSLevel2}>{dPMSLevel2}</option>)
  }
  if (dataDrp.Level1DropDownVal === "#11187A UPPAP Finished Parts Packaging Form") {
    Level2DropDownVals = uPPAP_A_Level2.map((uPPAP_A_Level2, key) => <option key={key} value={uPPAP_A_Level2}>{uPPAP_A_Level2}</option>)
  }
  if (dataDrp.Level1DropDownVal === "#11187B UPPAP Raw Materials Packaging Form") {
    Level2DropDownVals = uPPAP_B_Level2.map((uPPAP_B_Level2, key) => <option key={key} value={uPPAP_B_Level2}>{uPPAP_B_Level2}</option>)
  }
  const Level1DropDownVals = Level1DropDownVal.map((Level1DropDownVal, key) => <option key={key} value={Level1DropDownVal}>{Level1DropDownVal}</option>)

  function handleLevel1DrpChange(e) {
    setDrpName({ ...dataDrp, Level1DropDownVal: e.target.value });
  }

  function handleLevel2DrpChange(e) {
    setDrpName({ ...dataDrp, Level2DropDownVal: e.target.value });
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (dataDrp.Level2DropDownVal !== "" && dataDrp.Level1DropDownVal !== "") {
      const isSubmitConfirm = window.confirm('Are you sure you want to submit this request?');
      if (isSubmitConfirm) {
        event.preventDefault();
        if (dataDrp.Level2DropDownVal === "1. New Scrap Evaluation") {
          navigate('/NewScrapEvaluation');
        }
        if (dataDrp.Level2DropDownVal === "2. Confirm Mutilation") {
          navigate('/ConfirmMutilation');
        }
        if (dataDrp.Level2DropDownVal === "Step1-New Marking & Traceability Request") {
          navigate('/NewMarkingApprovalForm');
        }
        if (dataDrp.Level2DropDownVal === "Step1-Update Existing Marking Request") {
          navigate('/UpdateExistingMarkingRequest');
        }
        if (dataDrp.Level2DropDownVal ==="Step2-Pictures Marking Approval Request") {
          navigate('/PictureMarkingApprovalRequest');
        }
        if (dataDrp.Level2DropDownVal === "1. New Finished Parts Request") {
          navigate('/NewFinishedPartRequstForm');
        }
        if (dataDrp.Level2DropDownVal === "2. Update Existing Finished Part Request") {
          navigate('/UpdateExistingFinishedPartRequest');
        }
        if (dataDrp.Level2DropDownVal === "1. New Raw Materials Request") {
          navigate('/NewRawMaterialsRequstForm');
        }
        if (dataDrp.Level2DropDownVal === "2. Update Existing Raw Materials Request") {
          navigate('/UpdateExistingRawMaterialsRequest');
        }
      }
    } else {
      alert("Please make sure both Application Name and Level#2 fields are selected");
    }
  }


  const onClickCancelHandler = async (event) => {
    const isConfirmedCancel = window.confirm('You might loose the data, Are you sure you want to Cancel this request?');
    if (isConfirmedCancel) {
      setDrpName({ ...dataDrp, Level1DropDownVal: "-- Select --" });
      setDrpName({ ...dataDrp, Level2DropDownVal: "-- Select --" });
    }

  }
  // auth && auth.userData
  if (auth && auth.userData) {
    return (
      <form onSubmit={handleSubmit}>
        <div class="container">
          <div class="row">
            <div class="col-8 p-0">
              <img src={imgLogo} alt="Logo" width="100%" height="80%" />
            </div>
            <div class="col-4 p-0">
              <img src={rightLogo} alt="Logo" width="100%" height="80%" />
            </div>
          </div>
          <div className="row align-items-center" style={{ position: 'relative' }}>
            <div className="col-10">
              <p style={{ color: "#333" }}>This application is used for Online Forms. Please select a form and a Sub Form to continue.</p>
              <p style={{ color: "#333" }}>For technical or accessibility issues, please contact P&WC Help Desk: (450) 647-3824</p><br />
            </div>
            <div className="col-2 d-flex justify-content-end align-items-center" style={{ position: 'relative' }}>
              <img
                src={sofHelpIcon}
                alt="Help"
                style={{ width: '40px', height: '40px', cursor: 'pointer', float: 'right', marginTop: '-60px' }}
                onMouseEnter={() => setShowHelpModal(true)}
                onMouseLeave={() => setShowHelpModal(false)}
                onClick={() => setShowHelpModal(true)}
              />
              {showHelpModal && (
                <div
                  style={{
                    position: 'absolute',
                    top: '110%',
                    right: 0,
                    zIndex: 9999,
                    background: 'white',
                    border: '1px solid #ccc',
                    borderRadius: '8px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                    padding: '16px',
                    minWidth: '600px',
                    maxWidth: '600px',
                    height: '280px',
                    overflowY: 'auto',
                  }}
                  onMouseEnter={() => setShowHelpModal(true)}
                  onMouseLeave={() => setShowHelpModal(false)}
                >
                  {helpMessage}
                </div>
              )}
            </div>
          </div>
          <div class="row">
            <div class="col-2">
              <label for="fname">Form Name <p style={{ color: "red", float: "right" }}>*</p></label>
            </div>
            <div class="col-4">
              <select id="Level1" name="Level1" value={dataDrp.Level1DropDownVal} onChange={handleLevel1DrpChange} required>
                {Level1DropDownVals}
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-2">
              <label for="lname">Sub Form <p style={{ color: "red", float: "right" }}>*</p></label>
            </div>
            <div class="col-4">
              <select id="Level2" name="Level2" value={dataDrp.Level2DropDownVal} onChange={handleLevel2DrpChange} required>
                {Level2DropDownVals}
              </select>
            </div>
          </div>

          <div class="row">
            <div class="col-5">
              <input type="submit" value="Submit" /> &nbsp;
              <input type="button" value="Cancel" onClick={onClickCancelHandler} />
            </div>
          </div>
        </div>
      </form>
    )
  } else {
    return <div>Not logged in! Try to refresh to be redirected to login page.</div>;
  }

}

export default Home;
